module.exports = __webpack_public_path__ + "img/132.d989d337.svg";